export default __webpack_public_path__ + "static/media/LoginHeaderImage.d7dac332.png";